import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/how-to-play-screen/components/HowToPlayContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AppNav.tsx");
